export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Anime%20art%20style%20beautiful%20female%20character%20illustration%20with%20soft%20warm%20lighting%2C%20elegant%20flowing%20hair%2C%20cherry%20blossom%20petals%20in%20the%20air%2C%20dreamy%20atmospheric%20background%20with%20soft%20pink%20and%20peach%20tones%2C%20cinematic%20composition%2C%20high%20quality%20digital%20painting%2C%20romantic%20mood&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="羞羞动漫网站 - 动漫美女精品内容"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag before H1 */}
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-xs md:text-sm font-medium tracking-wider mb-5 whitespace-nowrap">
              每日更新 · 精品动漫推荐
            </span>

            {/* H1: Site name + core positioning */}
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
              羞羞动漫网站
              <span className="block text-primary-300 mt-2 text-2xl sm:text-3xl md:text-4xl lg:text-4xl">
                你的动漫美女精品内容乐园
              </span>
            </h1>

            {/* Slogan after H1 */}
            <p className="mt-4 text-white/70 text-sm md:text-base font-medium tracking-wide">
              汇集国漫精品与蜜桃动漫，发现最爱的动漫美女角色
            </p>

            {/* Description */}
            <p className="mt-6 text-white/80 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              羞羞动漫网站致力于为动漫爱好者提供动漫美女爆羞羞动漫在线蜜桃等国产精品动漫内容。
              通过51动漫国产精品入口直达精选作品，汇集精品动漫推荐与海量动漫美女角色资源，
              支持免费在线看蜜桃动漫大全。每日更新新番、美图与社区热帖，
              是动漫爱好者获取动漫美女角色内容和精品动漫推荐的首选平台。
            </p>

            {/* Stats */}
            <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">200万+</div>
                <div className="text-xs md:text-sm text-white/65 mt-1">月活跃用户</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">5000+</div>
                <div className="text-xs md:text-sm text-white/65 mt-1">动漫作品收录</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-white/65 mt-1">内容运营节奏</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#topics"
                onClick={(e) => handleScrollTo(e, '#topics')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-fire-line text-lg"></i>
                探索热门话题
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer backdrop-blur-sm transition-all duration-200 border border-white/20"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看热度榜单
              </a>
            </div>
          </div>

          {/* Right: Visual Image */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[340px] sm:h-[460px] md:w-[380px] md:h-[500px] rounded-2xl overflow-hidden border border-white/15">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20anime%20female%20character%20portrait%20with%20long%20silky%20hair%2C%20gentle%20expression%2C%20wearing%20beautiful%20kimono%20with%20floral%20patterns%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20warm%20lighting%2C%20dreamy%20romantic%20atmosphere%2C%20high%20quality%20anime%20illustration%2C%20pink%20and%20peach%20color%20palette&width=760&height=1000&seq=hero-visual-right&orientation=portrait"
                alt="羞羞动漫网站 - 动漫美女角色主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}